import React from "react";
import PageTitle from "../../assets/images/city-image-navigation.jpeg";
import TTSForm from "../../components/common/TTSForm";
import ImgCarOnTheRoad from "../../assets/images/car-on-the-road-night.jpeg";
import { products } from "../../data/products";
import ImgCityHd from "../../assets/images/city-hd-1.jpg"
export default function ShellTTS() {
  const pageImage = products.find((p) => p.link === window.location.pathname)?.img;

  const labelStyle: any = {
    marginRight: "20px",
  };
  return (
    <div className="container-fluid animate pageWrapper">
      {/* <!--Page--> */}
      <div className="container-fluid animate pageWrapper">
        {/* <!--pageTitle--> */}
        <div
          className="container-fluid section pageTitle"
          style={{
            backgroundImage: `url(${PageTitle})`,
          }}
        >
          <div className="container-fluid container">
            {/* <!--Text--> */}
            <div className="row middle-xs start-xm center-xs reverse">
              <div className="col-lg-4 col-md-3 col-sm-3 col-xm-2 col-xs-12 end-xm center-xs">
                <div className="slogan"></div>
              </div>
              <div className="col-lg-8 col-md-9 col-sm-9 col-xm-10 col-xs-12 title">
                <h1>Shell Taşıt Tanıma Sistemi</h1>
                <span className="breadcrumbs">
                  <a href="/">Anasayfa</a> {">"} <a href="/urunler">Ürünler</a>{" "}
                  {">"} <a href="#">Shell Taşıt Tanıma Sistemi</a>
                </span>
              </div>
            </div>
            {/* <!--/Text--> */}
          </div>
        </div>
        {/* <!--/pageTitle--> */}
        {/* <!--page--> */}
        <div className="container-fluid section page-section">
          <div className="container-fluid container">
            {/* <!--Title--> */}
            <div className="row center-xs">
              <div className="col-lg-12 col-xs textRow">
                <h2 className="title">
                  <b>Shell Taşıt Tanıma Sistemi</b>
                </h2>
              </div>
            </div>
            {/* <!--/Title--> */}
            {/* <!--urunler--> */}
            <div className="row mt-3 start-sm center-xs">
              {/* <!--urun--> */}
              <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                <div className="productBox">
                  <span className="Image">
                    <img
                      src={pageImage ?? ""}
                      height="263"
                      width="375"
                    />
                  </span>
                </div>
              </div>
              {/* <!--/urun--> */}
              <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                <div className="textCapsule">
                  <h3>Shell Taşıt Tanıma Sistemi Nedir?</h3>

                  <p>
                    Shell Taşıt Tanıma Sistemi 1996 yılında
                    T&uuml;rkiye&rsquo;de ilk defa Shell tarafından kullanılan
                    akaryakıt harcamalarının tek merkezden kontrol altına
                    alınmasını sağlayan bilgisayar destekli bir Filo
                    Y&ouml;netim Sistemidir.
                  </p>

                  <p>
                    Bug&uuml;n &uuml;lke genelinde Shell markası ile taşıt
                    tanıma hizmeti veren 1000+ istasyon sayısıyla 30.000
                    firmanın 600.000 aracına hizmet vermektedir.
                  </p>

                  <p>
                    Depo b&ouml;l&uuml;m&uuml;ne takılan cihazlar ile plakaya
                    tanımlı akıllı anahtarlıklar sayesinde sistem aracınızı
                    tanır. Harcamalarınız raporlanır ve takip edilebilir.
                    Faturalandırma aylık olarak yapılır ve muhasebesel işlemler
                    ile vakit kaybetmezsiniz.
                  </p>
                </div>
              </div>
            </div>
            {/* <!--/urunler--> */}
            {/* <!--avantajlar--> */}
            <div className="row mt-4">
              <div className="col-xs-12 start-sm center-xs">
                <div className="textCapsule">
                  <h3 className="paddingBottom">
                    Shell Taşıt Tanıma Sistemi Nedir?
                  </h3>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 advantage-box">
                <div className="icon01">
                  <h3>Araçtan inmeden akaryakıt ikmali</h3>
                  <ul>
                    <li>
                      Türkiye geneline yayılmış 1000’e yakın Shell istasyonu
                      Shell Taşıt Tanıma Sistemi (Shell TTS) ile donatılmıştır.
                    </li>
                    <li>
                      Filo araçları istasyonda vakit kaybetmeden pratik ve hızlı
                      akaryakıt ikmali sağlar.
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 advantage-box">
                <div className="icon02">
                  <h3>Filoların yakıt yönetiminde kolaylık</h3>
                  <ul>
                    <li>
                      Ofisinizden çıkmadan filonuzu rahatça yönetebilirsiniz.
                    </li>
                    <li>
                      Verilerinizi analiz ederek yakıt maliyetinizi kolayca
                      denetleyebilirsiniz.
                    </li>
                    <li>
                      Araç ve filo bazında limit yönetimi ile yakıt tüketimini
                      kontrol altına alabilirsiniz.
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 advantage-box">
                <div className="icon03">
                  <h3>Muhasebe kolaylığı</h3>
                  <ul>
                    <li>
                      Ayda 2 kez kesilen toplu faturalar ile operasyonel
                      kolaylık sağlayabilirsiniz.
                    </li>
                    <li>
                      Net ve anlaşılır faturalar ile muhasebe ve idari
                      işlemlerinizin iş yükünü azaltabilirsiniz.
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 advantage-box">
                <div className="icon04">
                  <h3>Ödeme kolaylığı</h3>
                  <ul>
                    <li>
                      Kredi kartı ödeme yöntemi ile Shell Taşıt Tanıma Sistemi
                      (Shell TTS) kullanarak nakit yönetiminde rahatlık
                      sağlayabilirsiniz.
                    </li>
                    <li>
                      Tüm filonun yakıt alımını tek fatura üzerinden kolayca
                      yönetebilirsiniz.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* <!--/avantajlar--> */}
            {/* <!--nerelerde--> */}
            <div className="row mt-4">
              <div className="col-xs-12 start-sm center-xs">
                <div className="textCapsule">
                  <h3 className="paddingBottom">
                    Shell Taşıt Tanıma Sistemi Nerelerde Kullanılır
                  </h3>
                </div>
              </div>
              <div className="col-lg col-md col-sm-12 col-xm-12 col-xs-12">
                <div className="where-box">
                  <div className="row middle-xs">
                    <div className="col-sm-3 col-xs-4">
                      <p className="icon01">
                        <b>81</b>
                        <br />
                        İl
                      </p>
                    </div>
                    <div className="col-sm-9 col-xs-8">
                      <p>
                        Türkiye Genelinde 81 ili Kapsayan Geniş İstasyon Ağı!
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg col-md col-sm-12 col-xm-12 col-xs-12">
                <div className="where-box">
                  <div className="row middle-xs">
                    <div className="col-sm-4 col-xs-4">
                      <p className="icon02">
                        <b>1000+</b>
                        <br />
                        İstasyon
                      </p>
                    </div>
                    <div className="col-sm-8 col-xs-8">
                      <p>
                        Shell Taşıt Tanıma Sistemi (TTS) Üyesi Benzin
                        İstasyonlarından Aracınızdan İnmeden Benzin
                        Alabilirsiniz!
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <!--/nerelerde--> */}
            {/* <!--Taşıt Kimlik Üniteleri--> */}
            {/* <div className="row mt-4">
              <div className="col-xs-12">
                <div className="textCapsule">
                  <h3 className="bottomline"> Taşıt Kimlik Üniteleri </h3>
                  <h4>2 adet Taşıt Kimlik Ünitesi bulunmaktadır.</h4>
                  <p>
                    <b>Akıllı Halka</b>
                    <br /> &nbsp;&nbsp;&bull; Araca monte edilir.
                    <br /> &nbsp;&nbsp;&bull; Araçtan inmeden, güvenli ve hızlı
                    akaryakıt ikmali sağlar.
                    <br /> &nbsp;&nbsp;&bull; Km sayacına bağlanmaz, km
                    okuyamaz.
                    <br /> &nbsp;&nbsp;&bull; Hızlı ve kolay monte edilir.
                  </p>

                  <p>
                    <a
                      href="../../Content/file/akilli_halka_uzaktan_programlama.pdf"
                      className="file"
                      target="_blank"
                    >
                      "Akıllı halka Uzaktan programlama" broşürünü için
                      tıklayınız
                    </a>
                  </p>
                  <p>
                    <b>Akıllı Anahtarlık</b>
                    <br /> &nbsp;&nbsp;&bull; Montaj gerektirmez, elde taşınır.
                    <br /> &nbsp;&nbsp;&bull; Km okuyamaz.
                    <br /> &nbsp;&nbsp;&bull; Araçtan inmeden, güvenli ve hızlı
                    akaryakıt ikmali sağlar.
                  </p>
                </div>
              </div>
            </div> */}
            {/* <!--/Taşıt Kimlik Üniteleri--> */}
            {/* <!--TTS Montaj ve Servis Merkezleri--> */}
            {/* <div className="row mt-4">
              <div className="col-xs-12">
                <div className="textCapsule">
                  <h3 className="bottomline">
                    {" "}
                    TTS Montaj ve Servis Merkezleri
                  </h3>
                  <p>
                    <a
                      href="../../Content/file/turpak-regional-service-list-coorded-shell-dec.xlsx"
                      className="file"
                    >
                      TTS Servis Noktaları
                    </a>
                  </p>
                </div>
              </div>
            </div> */}
            {/* <!--/TTS Montaj ve Servis Merkezleri--> */}
          </div>
        </div>
        {/* <!--/page--> */}
        {/* <!--login--> */}
        
        {/* <!--/login--> */}
        {/* <!--talep-formu--> */}
        <div className="container-fluid section page-form-section">
          <div className="container-fluid container">
            {/* <!--Text--> */}
            
            {/* <!--/Text--> */}
            <TTSForm />
          </div>
        </div>
        {/* <!--/talep-formu--> */}
      </div>
      {/* <!--//Page--> */}
      {/* <script type="text/javascript">
        function updateSelectedValues() {
            // Tüm işaretlenmiş checkbox'ları seçiyoruz
            const checkboxes = document.querySelectorAll('input[name="RequestForm.ProductType"]:checked');
            const selectedValues = [];
            // Seçili checkbox'ların value değerlerini topluyoruz
            checkboxes.forEach((checkbox) => {
                selectedValues.push(checkbox.getAttribute('data-id')); // Değerleri doğrudan alıyoruz
            });
            // Değerleri input alanına yazdırıyoruz
            document.getElementById('selectedValues').value = selectedValues.join(', ');
        }
    </script> */}
    </div>
  );
}
